module.exports = __webpack_public_path__ + "static/media/driver.e0d5c7ac.svg";